(function () {
    'use strict';

    a3_cabin_reports.directive('requestItem', requestItem);
    /**
    * @memberof CabinReports
    * @ngdoc directive
    * @name requestItem
    * @restrict E
    * @description
    *   Request info
    * @example
    *   Usage:
    *   <request-item request="request" request-type="Flight" on-deleted="deleteRequest(requestId, requestType)"></request-item>
    * @ngInject
    */
    function requestItem($uibModal, RequestFactory) {
        function link(scope,element, attrs) {
            //scope.request
            scope.loading = false;
            scope.errorMessage = null;
            scope.contents = {
                showPendingIcon: false, 
                //sholwAcknowledgedIcon: false,
                showAcceptedIcon: false,
                showRejectedIcon: false,
                showFullRequestComment: false,
                showFullRejectComment: false,
                rejectReason: "",
                infoMessage: "",
                loading: false,
                showErrorMessage: false,
                errorMessage: "" ,
                textclass:""
            };
            
            scope.confirmCancelRequest =confirmCancelRequest;
            scope.toggleFullCommentVisibility = toggleFullCommentVisibility;
            scope.toggleFullRejectCommentVisibility = toggleFullRejectCommentVisibility;
            scope.todayDate = moment().format('DD/MM');

            getFlightDescription();

            function getFlightDescription(){
                scope.request.FlightDescription = null;
                if(scope.request.FlightNo){
                    scope.request.FlightDescription = scope.request.FlightNo;
                }else if(scope.request.FlightDutyCategory){
                    scope.request.FlightDescription = scope.request.FlightDutyCategory;
                }else if(scope.request.AfterTime && scope.request.BeforeTime){
                    scope.request.FlightDescription = moment.utc(scope.request.AfterTime).format('HH:mm') + " - " + moment.utc(scope.request.BeforeTime).format('HH:mm');      
                }else if(scope.request.AfterTime){
                    scope.request.FlightDescription = "after " + moment.utc(scope.request.AfterTime).format('HH:mm');
                }else if(scope.request.BeforeTime){
                    scope.request.FlightDescription = "till " + moment.utc(scope.request.BeforeTime).format('HH:mm');
                }

            }

            //Toggles comments
            function toggleFullCommentVisibility(){
                scope.contents.showFullRequestComment =  !scope.contents.showFullRequestComment;
            }
            function toggleFullRejectCommentVisibility(){
                scope.contents.showFullRejectComment =  !scope.contents.showFullRejectComment;
            }


            getContents();


            //update contents obj:
            function getContents(){
                if (scope.request.StatusText == "FinalAccepted" ){
                    scope.contents.textclass = "text-green";
                    scope.contents.showAcceptedIcon = true;
                    scope.contents.infoMessage="your request has been accepted!";

                } else if (scope.request.StatusText == "Accepted"){
                    scope.contents.textclass = "text-indigo";
                    scope.contents.showPendingIcon = true;
                    scope.contents.infoMessage ="your request is under review!";
                } else if (scope.request.StatusText == "Pending"){
                    scope.contents.textclass = "text-light-blue";
                    scope.contents.showPendingIcon = true;
                    scope.contents.infoMessage ="your request is pending!";

                }else if (scope.request.StatusText == "Acknowledged"){
                    scope.contents.textclass = "text-light-blue";
                    scope.contents.showPendingIcon = true;
                    scope.contents.infoMessage="your request is under review!";
               
                }else if (scope.request.StatusText == "Rejected"){
                    scope.contents.rejectReason = scope.rejectReason;
                    scope.contents.textclass = "text-red";
                    scope.contents.showRejectedIcon = true;
                    scope.contents.infoMessage="your request has been rejected!";
                }
            }

            /**
             * Opens confirmation modal for the request cancel action
             * @memberof request
             */
            function confirmCancelRequest() {
                bootbox.dialog({
                    message: "<strong>You are about to cancel your request. Are you sure?</strong><br/><br/>",
                    title: "Caution!",
                    buttons: {
                        confirm:{
                            label: 'Confirm',
                            className: "btn-danger",
                            callback: function(){
                                cancelRequest();
                            }
                        },  
                        cancel:{
                            label: "Cancel",
                            className: "btn-default",
                            callback: function(){}
                        }
                    }
                })
            }

            function cancelRequest(){
                scope.contents.loading = true;
                if(scope.requestType == "Flight"){
                    RequestFactory.deleteFlightRequest(scope.request.Id).then(function (res) {
                        handleDeleteResponse(res);
                    }).catch(function(){
                        handleErrorResponse();
                    });
                }
                else if(scope.requestType == "Ground"){
                    RequestFactory.deleteGroundRequest(scope.request.Id).then(function (res) {
                        handleDeleteResponse(res);
                    }).catch(function(){
                        handleErrorResponse();
                    });
                }
                else if(scope.requestType == "ShiftTime"){
                    RequestFactory.deleteShiftRequest(scope.request.Id).then(function (res) {
                        handleDeleteResponse(res);
                    }).catch(function(){
                        handleErrorResponse();
                    });
                }
                else if(scope.requestType == "Overnight"){
                    RequestFactory.deleteOvernightRequest(scope.request.Id).then(function (res) {
                        handleDeleteResponse(res);
                    }).catch(function(){
                        handleErrorResponse();
                    });
                }
                else if(scope.requestType == "Other"){
                    RequestFactory.deleteOtherRequest(scope.request.Id).then(function (res) {
                        handleDeleteResponse(res);
                    }).catch(function(){
                        handleErrorResponse();
                    });
                }
            }

            function handleDeleteResponse(res){
                scope.contents.loading = false;
                if(res.success == true){ 
                    scope.refreshRequests();

                }else{
                    scope.contents.showErrorMessage = true;
                    scope.contents.errorMessage = "Cancel request failed."
                }
            }
            function handleErrorResponse(){
                scope.contents.loading = false;
                scope.contents.showErrorMessage = true;
                scope.contents.errorMessage = "Cancel request failed."

            }
        }

        return {
            restrict: 'E',
            terminal: false,
            templateUrl: 'views/RosterRequests/requestItem.tpl.html',
            scope : {
                request: '=',
                requestType: "@",
                rejectReason: "@",
                refreshRequests: "&",
                isHistoryView: '@'
            },
            link: link
        }
    }

})();